// extracted by mini-css-extract-plugin
module.exports = {"fragmentMargin":"fragment_fragmentMargin__3OrWI"};